import React from "react";
import styled from "styled-components";

const StyledInput = styled.input`
  width: 100%;
  height: 32px;
  background-color: #f5f5f5;
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  color: #000000e5;
  padding: 0 12px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s;

  &:hover {
    border-color: #f5f5f5;
  }

  &:focus {
    border-color: #1890ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &::placeholder {
    color: #666;
  }
`;

interface UserStringSetterProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
}

export const UserStringSetter: React.FC<UserStringSetterProps> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <StyledInput
      value={value || ""}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
    />
  );
};